export default "__VITE_ASSET__5zsZAm1w__"